import { Injectable } from '@angular/core';
import { HttpEvent, HttpInterceptor, HttpHandler, HttpRequest, HttpErrorResponse } from '@angular/common/http';
import { Observable, takeUntil, throwError } from 'rxjs';
import { switchMap, catchError } from 'rxjs/operators';
import { RecaptchaService } from './recaptcha.service';
import { ERecaptchaEnum } from './recaptcha.enum';
import { Unsubscribe } from '@pc/shared';

@Injectable()
export class RecaptchaInterceptor extends Unsubscribe implements HttpInterceptor {
  constructor(private recaptchaService: RecaptchaService) {
    super();
  }

  intercept(
    req: HttpRequest<unknown>,
    next: HttpHandler,
    userId: string | null = null
  ): Observable<HttpEvent<unknown>> {
    const url = req.url.split('/');
    const action = url[url.length - 1];
    return this.recaptchaService.getRecaptchaToken(action).pipe(
      takeUntil(this.unsubscribe$),
      switchMap((token) => {
        if (token) {
          console.log('recaptchaService :Headers have been added');
          req = req.clone({
            headers: req.headers
              .append('recaptcha-token', token ?? '')
              .append('recaptcha-action', action ?? '')
              .append('recaptcha-userid', userId ?? '')
          });
        }
        return next.handle(req).pipe(
          catchError((error: HttpErrorResponse) => {
            if (error.status === ERecaptchaEnum.STATUS_FAILED) {
              console.error(ERecaptchaEnum.MESSAGE_FAILED);
            }
            return throwError(() => error);
          })
        );
      })
    );
  }
}
